
import { defineComponent } from 'vue'
import Collection from '@/components/organisms/Collection.vue'

export default defineComponent({
  components: {
    Collection,
  },
})
